import { useState, useEffect } from 'react';

export interface RecentLandingPage {
  slug: string;
  event: {
    title: string;
    location: string | null;
  };
}

/**
 * Fetches recently published event landing pages for public discovery (footer).
 * Only landing pages have a public, crawlable URL (`/alleen-naar-:slug`); the
 * event detail pages themselves are login-gated, so we surface landing pages
 * rather than raw events to avoid linking logged-out visitors into a login wall.
 */
export const useRecentLandingPages = (limit: number = 4) => {
  const [pages, setPages] = useState<RecentLandingPage[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    const fetchRecent = async () => {
      try {
        setLoading(true);
        setError(false);

        const res = await fetch(`/api/landing-pages/recent?limit=${limit}`);
        if (!res.ok) throw new Error(`Request failed: ${res.status}`);

        const json = await res.json();
        setPages(Array.isArray(json?.data) ? json.data : []);
      } catch (err) {
        console.error('Error fetching recent landing pages:', err);
        setError(true);
      } finally {
        setLoading(false);
      }
    };

    fetchRecent();
  }, [limit]);

  return { pages, loading, error };
};
